import services from './services.js';
import NProgress from 'nprogress';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    MAP_LIST
} from '$http';
import $http from '$http';

//组件
import {
    GetT_HardwareByPage,
    MAP_STATUS_LIST,
    MAP_SIZE_LIST
} from '@api/hardWareApi';
import pagination from 'pagination';
import complexSearch from '@pages/CRMFormatAgent/components/complex-search/index.vue';
import agentAccountManageDialog from './components/agentAccountManageDialog/index.vue';
import financialDetailsListDialog from './components/financialDetailsListDialog/index.vue';
import kingdeeDialog from './components/kingdeeDialog/index.vue';
export default {
    mixins: [services],
    components: {
        pagination,
        complexSearch,
        agentAccountManageDialog,
        financialDetailsListDialog,
        kingdeeDialog
    },
    data() {
        return {
            formInline: {
                user: '',
                region: ''
            },
            lists: [],
            sels: [], //列表选中列
            SaleCheckView: false,
            pageSizes: [10, 20, 50],
            loading2: false,
            statusList: MAP_STATUS_LIST,
            sizeList: MAP_SIZE_LIST,
            intentProject: MAP_LIST.INTENT_PROJECT,
            choiceProjectType: [],
            query: this.getQueryParam(),
            filterData: {},
            searchVisiable: false
        }
    },

    watch: {
        '$route' (to, from) {
            if (this.$route.path == '/acountManage/CRMAgentAccountManage') {
                this.getDataList();
            }
        }
    },
    computed: {
        arrowClass() {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
        bgStyle() {
            if (this.searchVisiable) {
                return {
                    'backgroundColor': '#e8e8e8'
                };
            }
            return {
                'backgroundColor': '#fff'
            };
        }
    },
    methods: {
        toggleSearch() {
            this.searchVisiable = !this.searchVisiable;
        },
        complexSearch(data) {
            this.filterData = data;
            this.getDataList();
        },
        resetFilterData() {
            this.filterData = {};
            this.getDataList();
        },
        getQueryParam() {
            return cloneDeep({
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: 1,
                pageSize: 10,
                total: 0,
                orderBy: ""
            });
        },
        //查询
        onQuerySubmit() {
            this.query.pageIndex = 1;
            this.query.projectType = this.choiceProjectType.join(",");
            this.getDataList();
        },
        //重置查询条件
        onQueryClean: function (formQuery) {
            util.resetFormQueryParam(formQuery);
            this.getDataList();
        },
        // 查看
        handleView(item) {
            this.$refs.refagentAccountManageDialog.show({
                agentId: item.Id,
                isUpdate: false
            });
        },
        // 修改
        updateFn(item) {
            this.$refs.refagentAccountManageDialog.show({
                agentId: item.Id,
                isUpdate: true
            });
        },
        // 明细
        lookDetails(item) {
            this.$refs.refFinancialDetailsListDialog.show({
                agentId: item.Id
            });
        },
        // 金蝶明细
        // kingdeeDetails(item) {
        //     this.$refs.kingdeeDialog.show({
        //         agentId: item.Id
        //     });
        // }
        // 借款明细
        lendDetails(item) {
            console.log(item)
            this.$router.push({
                path: '/acountManage/AgentLend',
                query: {
                    AgentId: item.Id
                }
            });
        }
    },
    created() {
        this.getDataList();
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentAccountManage/vm.js